<template>
  <div class="text-body-1 font-weight-bold mx-3">{{ number }}.</div>
</template>

<script>
export default {
  name: 'SurveyQuestionNumber',
  props: {
    number: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
